import { render, staticRenderFns } from "./NoFeature.vue?vue&type=template&id=65276599"
import script from "./NoFeature.vue?vue&type=script&lang=js"
export * from "./NoFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports